export default "__VITE_ASSET__tM2hbdLE__"